var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG2A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.48 20.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-G2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3,5.68,8.74,2.75c.18-.35.38-.84.59-1.24.24.45.44.9.7,1.46l1.26,2.54c.28.56.5.91,1.15,1,.49-.07,1-.15,1.47-.21l.39-.79-1.58-.23c-.2,0-.16-.07-.31-.36L10.1.34A1,1,0,0,0,8.62.28C8.39.51,6.49,4.49,6.18,5.12c-.1.19,0,.17-.29.2-1.41.19-2.82.42-4.24.62C1.15,6,.53,6,.21,6.44A1,1,0,0,0,.34,7.81L3,10.44l1,1c.07.07.07.07.05.17l-.88,5.22a1,1,0,0,0,.3.78l.67.28c.31.06.85-.3,1.07-.41l4.11-2.15,1.69.88.22-1.31A6.15,6.15,0,0,0,9.34,14,8.34,8.34,0,0,0,7,15.09L4.5,16.41c0-.1,0-.2.06-.28l.75-4.34a1.36,1.36,0,0,0-.42-1.29l-1-1L1.52,7.21l4.54-.64a1.37,1.37,0,0,0,1.24-.9Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.54,7.51c-1.42.19-2.85.41-4.29.62-.5.07-1.13.07-1.46.5A1,1,0,0,0,8.92,10l2.74,2.65,1,1c.07.07.07.07,0,.17l-.28,1.65-.22,1.31-.39,2.32a1,1,0,0,0,.3.79l.68.29c.32.06.86-.3,1.09-.42L18,17.6l4.46,2.33.79.26a1,1,0,0,0,1-1.08l-.91-5.38c.09-.15,3.88-3.68,4-4a1.09,1.09,0,0,0,0-1,1,1,0,0,0-.9-.56l-5-.73c-.2,0-.16-.07-.31-.37L18.8,2.46a1.05,1.05,0,0,0-1.5,0c-.15.15-1,1.93-1.7,3.32L15,6.92c-.08.17-.15.3-.18.38s0,.18-.3.21Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG2A);
export default __webpack_public_path__ + "static/media/G2A.2b114cca14fac88719afa188643eca17.svg";
export { ForwardRef as ReactComponent };